import axios from 'axios'
import * as Hook from 'console-hook'
import * as stringify from 'json-stringify-safe'
import * as _ from 'lodash'
import { sizeof } from 'sizeof'
import config from '../config'

function getOS () {
  var userAgent = window.navigator.userAgent
  var platform = window.navigator.platform
  var macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
  var windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
  var iosPlatforms = ['iPhone', 'iPad', 'iPod']
  var os = null

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS'
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS'
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows'
  } else if (/Android/.test(userAgent)) {
    os = 'Android'
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux'
  }

  return os
}

function getState () {
  try {
    return JSON.parse(window.localStorage.getItem('state'))
  } catch (error) {
    return {}
  }
}

const loggerUrl = 'https://orderapp-logger-ssj7hdeukq-de.a.run.app/'
let logs = []
let flushIntervalId
const platform = getOS()
let m

const LOG_MAX_LENGTH = 500
const LOG_MAX_SIZE = 1000000
const FLUSH_INTERVAL = 15000

const version = _.get([...document.getElementsByTagName('META')].filter(o => o.name === 'ui-version'), '0.content')

const loggerService = {
  init: ({ merchantId }) => {
    m = merchantId
    const state = getState()
    const isWaiter = _.get(state, 'user.permissions', []).some(p => p.includes(':waiter'))

    const hook = (method, args) => {
      if (isWaiter) {
        if (['log', 'info', 'warn', 'debug'].includes(method)) {
          return
        }
      }
      logs.push({
        m: method,
        a: _.mapValues(args, arg => {
          if (
            _.get(arg, 'constructor.name') === 'Error'
          ) {
            return arg.toString()
          }
          return arg
        }),
      })

      if (
        logs.length >= LOG_MAX_LENGTH ||
        sizeof(logs) > LOG_MAX_SIZE
      ) {
        loggerService.flush()
      }
    }

    Hook().attach('log', hook)
    Hook().attach('error', hook)
    // silence console.info
    Hook(console, true).attach('info', hook)
    // silence debug and warning in production env
    Hook(console, config.environment === 'production').attach('warn', hook)
    Hook(console, config.environment === 'production').attach('debug', hook)

    if (flushIntervalId) {
      clearInterval(flushIntervalId)
    }
    flushIntervalId = window.setInterval(() => {
      if (logs.length) {
        loggerService.flush()
      }
    }, FLUSH_INTERVAL)
  },
  flush: async () => {
    const _logs = _.clone(logs)
    logs = []
    const state = getState()
    const isWaiter = _.get(state, 'user.permissions', []).some(p => p.includes(':waiter'))

    return axios.post(`${loggerUrl}c/log`, stringify({
      logs: _logs,
      info: {
        // eslint-disable-next-line no-undef
        v: version, // typeof __APPVERSION__ === 'undefined' ? '__APPVERSION__' : __APPVERSION__,
        p: platform,
        m,
        d: _.get(state, 'user.id'),
        c: isWaiter ? 'WAITER' : 'CUSTOMER',
        e: config.environment,
        u: _.get(state, 'user.id'),
      },
    }),
    {
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'text',
    },
    )
  },
}

export default loggerService



// WEBPACK FOOTER //
// ./src/services/logger.js